import { Cell as CellType } from '@tanstack/react-table'

export const cellIndex = <T>(cell: CellType<T, unknown>): string => {
  const CELL_PREFIX = 'table-cell-'

  if (cell.row.getParentRow()) {
    return `${CELL_PREFIX}${cell.row.getParentRow()?.index}.${cell.row.index}_${cell.column.id}`
  }

  return `${CELL_PREFIX}${cell.row.index}_${cell.column.id}`
}
